import script from "./NewSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./NewSelect.vue?vue&type=script&setup=true&lang=js"

import "./NewSelect.vue?vue&type=style&index=0&id=3720c87b&scoped=true&lang=scss"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3720c87b"]])

export default __exports__